import { getSession } from "@/utils/methods";
import { renderData } from "@/api/list";
import { deepFindOne } from "@/utils/methods";

export const commonMixin = {
  data() {
    return {
      lang: '',
      userName: JSON.parse(sessionStorage.getItem("userInfo")).user.username,
      notFetchFields: ['id', 'rid', 'del_flag', 'placed', 'process_instance_id', 'line', 'sys_template_name', 'fmodalid', 'fsaved'],
      formulaList: [],
      editorList: [],
      // imageList: [],
      annexesList: [],
    }
  },
  watch: {
    // imageList: {
    //   handler(val) {
    //     this.$emit("imageList", val);
    //   },
    //   deep: true
    // },
    annexesList: {
      handler(val) {
        this.$emit("annexesList", val);
      },
      deep: true
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null;
    },
    configId() {
      return this.$route.query?.configId;
    },
    copy() {
      return this.$route.query.copy || "";
    },
    isView() {
      return this.$route.path.indexOf("view") !== -1;
    },
    productTypeId() {
      return this.$route.query.typeId;
    },
    productTypeNo() {
      return this.$route.query.typeNo;
    },
    productTypeName() {
      return this.$route.query.typeName;
    },
     routes() {
      return this.$store.state.global.routes;
    },
    // 是否显示版本按钮
    viewVersionDiabled() {
      // let path = this.$route.path;
      // return path === "/ck/wxht_edit" ||
      //   path === "/ck/cght_edit" ||
      //   path === "/ck/wxht_view" ||
      //   path === "/ck/cght_view";
      return this.config.isChange
    }
  },
  created() {
    this.lang = JSON.parse(sessionStorage.getItem('LanguageName'));
  },
  methods: {
    splitStr(value) {
      if (!value) {
        return value
      }
      // console.error('splitStr', value.split(","))
      return value.split(",");
    },
    // 采购合同号穿透跳转（付款管理和预付款申请限定）
    routerLink(row, field, value) {
      // console.error('routerLink', row, field)
      if (!field.jumpMenu) {
        return
      }
      // console.error('this.routes', this.routes)
      const router = deepFindOne(this.routes, "formConfigId", field.jumpMenu);
      if (!router) {
        this.$message.warning("没有菜单查看权限，请联系管理员");
        return;
      }
      const params = { configId: router.formConfigId, pageNum: 1, pageSize: 1 }
      const data = { filter: { fno: value || row[field.fieldName] } }
      renderData({ data, params })
        .then(res => {
          if (!res.result?.length) {
            this.$message.warning(this.$t("configMoudle.noFno"));
            return;
          }
          this.$router.push({
            name: `${router.path}_detailView`,
            query: {
              fno: value || row[field.fieldName],
              biaoshi: true,
              configId: router.formConfigId,
              id: res.result[0].id,
            },
          });
        })
    },
    // 计算列的 span 值
    spanSet(type) {
      return type === 6 ? 24 : 24 / 5;
    },
    // 计算样式
    getStyle(stretchTile) {
      const styles = {
        1: "width: 100%",
        2: "width: 264px",
        3: "width: 50%",
        4: "width: 30%"
      };
      return styles[stretchTile] || "width: 264px";
    },
    // 水单认领单独单独判断
    isSDRL() {
      return this.$route.query.configId === "1382157584785608705";
    },
    isSDRLShowFetch(formData) {
      if (this.isSDRL()) {
        // console.error('==============> isSDRL true')
        return formData.placed && formData.placed === "2";
      }
      return false;
    },
    // 判断是否为库存调拨模块
    iskcdb(childFormId) {
      return '1417393273672175617' === this.$route.query.configId && childFormId === '1417687335193153536'
    },
    showApproval() {
      return !!this.$route.query.peddingApproval;
    },
    noCustomerMaintenance() {
      return this.$route.query.configId === "1369185842387619841";
    },
    // 获取商品类别id
    getProductTypeId() {
      return this.productTypeId;
    },
    // 设置禁用状态
    setDisabled(readonly, approvalEdit) {
      try {
        if(this.isView) return true;
        if(this.curData && this.curData.id) {
          const placed = this.curData.placed || '';
          if(this.isChangeOrder) return readonly;
          if(readonly) return true;
          const isPlacedValid = (placed !== 0 && placed !== '0') && (placed !== -1 && placed !== '-1');
          if(isPlacedValid && approvalEdit) {
            if(!this.isEditableUnderApproval) this.isEditableUnderApproval = true;
            return false;
          }
          if((placed === 0 || placed === '0') || (placed === -1 || placed === '-1')) {
            if(readonly) return true;
          } else return true;
        } else if (readonly) return true;
        return false;
      } catch (e) {
        console.error(e, e.message);
      }
    }
  }
}